import React from 'react';
import Icon from '../../App/Candidates/StudentApp/Icon';
import { useWeb } from './WebContext';

export const Mark = ({ name, from, to }) => (
  <span className="web-mark sa-card" style={{ background: `linear-gradient(135deg, ${from}, ${to})` }}>
    <Icon name={name} />
  </span>
);

export const Xp = ({ amount, signed = true }) => (
  <span className="web-xp">
    <Icon name="star" />
    {signed ? `+${amount}` : amount} XP
  </span>
);

export const Chips = ({ group, options }) => {
  const { chips, setChip } = useWeb();

  return (
    <div className="web-chips">
      {options.map((option) => (
        <button
          key={option}
          type="button"
          className={chips[group] === option ? 'on' : ''}
          onClick={() => setChip(group, option)}
        >
          {option}
        </button>
      ))}
    </div>
  );
};
